export default __webpack_public_path__ + "static/media/tool2.1cfe9841.png";